import { Spin as AntSpin, SpinProps } from 'antd'

interface ExtendedSpinProps extends SpinProps {
    role?: string
}

const Spin = (props: ExtendedSpinProps) => {
    return <AntSpin size="large" {...props} />
}

export default Spin
